import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import { TidewaysContext } from './app/context'
import Navigator from './app/navigator'
import { ServiceType } from './domain/ServiceType'
import { parseQueryString } from './helper/queryString'
import { ServerCapability } from './helper/ServerCapability'
import CriticalTransactionsScene from './monitor/criticalTransactionsScene'
import EventNavigator from './monitor/events/navigator'
import Event from './monitor/events/view'
import ExternalCallsGraph from './monitor/external-calls-graph'
import ExternalOperations from './monitor/external-operations'
import Graph from './monitor/graph'
import MonitorNavigation from './monitor/monitor-navigation'
import { ApplicationState } from './redux/ApplicationState'
import { NavigationEntry } from './service-type-navigation'
import { UpgradeNecessary } from './upgrade'

interface StateProps {
    tidewaysContext: TidewaysContext
    parameters: { [key: string]: string }
    navigator: Navigator
    type: string
}

type Props = StateProps & RouteComponentProps

export class MonitorComponent extends React.Component<Props> {
    public render() {
        if (!this.props.tidewaysContext.application.license.monitoring) {
            return <UpgradeNecessary title={'Response Times'} featureName={'PHP Monitoring'} />
        }

        const route = 'XhprofOrganizationBundle.Application.show'
        const navigationEntries: NavigationEntry[] = [
            { label: 'PHP Performance', type: ServiceType.php, route },
            { label: 'External HTTP Calls', type: ServiceType.external, route },
        ]

        return (
            <div className="row">
                <div className="col-md-12">
                    <MonitorNavigation navigationEntries={navigationEntries} currentRoute={this.props.tidewaysContext.route} />
                    {this.props.type === ServiceType.php && (
                        <div className="row">
                            <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                                <Graph responseType="95p" />
                            </div>
                            {this.props.parameters.event ? (
                                <div>
                                    <div className="col-md-3">
                                        <EventNavigator />
                                    </div>
                                    <div className="col-md-9">
                                        <Event />
                                    </div>
                                </div>
                            ) : null}
                            {!this.props.parameters.event ? (
                                <div className="col-md-12 operation-list">
                                    <CriticalTransactionsScene />
                                </div>
                            ) : null}
                        </div>
                    )}
                    {this.props.type === ServiceType.external ? (
                        <div className="row">
                            <ServerCapability
                                level="warning"
                                checkForActivation
                                hideChildrenOnInactive={false}
                                capability={'HttpMonitoring'}
                            >
                                <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                                    <ExternalCallsGraph responseType="95p" />
                                </div>
                                <div className="col-md-12 operation-list">
                                    <ExternalOperations />
                                </div>
                            </ServerCapability>
                        </div>
                    ) : null}
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect<StateProps, {}>((globalState: ApplicationState, props: RouteComponentProps) => {
        return {
            tidewaysContext: globalState.tidewaysContext,
            parameters: parseQueryString(props.location.search),
            navigator: new Navigator(globalState.tidewaysContext.route),
            type: globalState.tidewaysContext.route.parameters.st ?? 'php',
        }
    })(MonitorComponent),
)
